import { render, staticRenderFns } from "./CertificateManagement.vue?vue&type=template&id=7d56fae5&scoped=true&"
import script from "./CertificateManagement.vue?vue&type=script&lang=js&"
export * from "./CertificateManagement.vue?vue&type=script&lang=js&"
import style0 from "./CertificateManagement.vue?vue&type=style&index=0&id=7d56fae5&prod&scoped=true&lang=css&"
import style1 from "./CertificateManagement.vue?vue&type=style&index=1&id=7d56fae5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d56fae5",
  null
  
)

export default component.exports